<template>
  <div class="solutions__filter filter">
    <div class="filter__toggle" data-fancybox-accordeon href="#filter">{{ title }} ({{cntFilters}})</div>
    <div class="filter__cont fancy-dropdow" id="filter">
      <div class="filter__close fancy-dropdow__close"></div>
      <div class="filter__list fancy-dropdow__cont">
        <div class="filter__item">
          <div class="filter__item-title">{{ title2 }}</div>
          <div class="filter-radios">
            <div class="filter-radios__item" v-for="subsection in subsections" v-bind:class="{'active': subsection.CHECKED}" :key="subsection.ID">
              <a :href="subsection.SECTION_PAGE_URL">
                <label class="filter-radios__label" for="type-0"><span>{{ subsection.NAME }}</span></label>
              </a>
            </div>
          </div>
        </div>

        <div v-for="select in selects" :key="select.ID" class="filter__item">
          <div class="filter__item-title">{{ select.NAME }}</div>
          <div class="filter-checkbox">
            <div class="filter-checkbox__item" v-for="value in select.VALUES" :key="value.CONTROL_ID">
              <input class="filter-checkbox__input" type="checkbox" :id="value.CONTROL_ID" :name="value.CONTROL_NAME"
                     :checked="value.CHECKED" :data-group-id="select.ID"
                     @change="checkChange">
              <label class="filter-checkbox__label" :for="value.CONTROL_ID">
                <span>{{ value.VALUE }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="filter__btn">
        <button class="default-btn default-btn--green" v-bind:class="classFilterApply" @click="setFilter">
          {{ filterApply }}
        </button>
        <button class="default-btn default-btn--dark filter__btn-clear" @click="resetFilters">{{ resetTitle }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
  name: "CatalogFilter",
  components: {},
  props: {
    form_name: String,
    form_action: String,
    selected_items: [Array, Object],
    selects: [Array, Object],
    checkboxes: [Array, Object],
    subsections: [Array, Object],
    title: {
      type: [String],
      default: BX.message('CATALOG_SMART_FILTER_TITLE')
    },
    title2: {
      type: [String],
      default: BX.message('CATALOG_SMART_FILTER_TITLE_2')
    },
    resetTitle: {
      type: [String],
      default: BX.message('CATALOG_SMART_FILTER_RESET')
    },
    filterApply: {
      type: [String],
      default: BX.message('CATALOG_FILTER_APPLY')
    },
  },
  data() {
    return {
      selTags: [],
      selected: {},
    }
  },
  methods: {
    ...mapActions([
      'SET_PRODUCTS'
    ]),
    checkChange(event) {
      if (event.target.checked) {
        if (!this.selected[event.target.getAttribute('data-group-id')])
          this.selected[event.target.getAttribute('data-group-id')] = [];

        this.selected[event.target.getAttribute('data-group-id')].push(event.target.name);
      } else {
        for (let key in this.selected[event.target.getAttribute('data-group-id')]){
          if (this.selected[event.target.getAttribute('data-group-id')][key] === event.target.name){
            delete (this.selected[event.target.getAttribute('data-group-id')][key]);
          }
        }
      }
    },
    selChange(event, id) {
      let options = [];
      Array.from(event.target.selectedOptions).forEach((opt) => {
        options.push(opt.getAttribute('name'));
      });
      this.selected[id] = options;
    },
    setFilter() {
      let url = window.location.pathname + '?set_filter=Y';

      for (let value in this.selected) {
        if (Array.isArray(this.selected[value])) {
          for (let val of this.selected[value]){
            url += val ? "&" + val + '=Y' : '';
          }
        } else {
          url += value ? "&" + value + '=Y' : '';
        }
      }

      window.location.href = url;
    },
    delSelect(key, id) {
      for (let selKey in this.selected)
        if (Array.isArray(this.selected[selKey])) {
          for (let subKey in this.selected[selKey]) {
            if (this.selected[selKey][subKey] === id) {

              delete (this.selected[selKey][subKey]);
              this.setFilter();
            }
          }
        } else if (selKey === id) {
          delete (this.selected[selKey]);
          this.setFilter();
        }
    },
    resetFilters() {
      location.href = location.pathname;
    },
    setSelected(items) {
      for (let itemKey in items) {
        for (let valKey in items[itemKey]['VALUES']) {
          if (items[itemKey]['VALUES'][valKey]['CHECKED']) {
            if (valKey === 'Y') {
              this.selected[items[itemKey]['VALUES'][valKey]['CONTROL_ID']] = items[itemKey]['VALUES'][valKey]['CONTROL_ID'];
            } else {
              if (!this.selected[items[itemKey]['ID']]) {
                this.selected[items[itemKey]['ID']] = [];
              }
              this.selected[items[itemKey]['ID']].push(items[itemKey]['VALUES'][valKey]['CONTROL_ID']);
              // this.selected[items[itemKey]['ID']][items[itemKey]['VALUES'][valKey]['CONTROL_NAME']] = items[itemKey]['VALUES'][valKey]['CONTROL_ID'];
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState([
      'moduleCatalog'
    ]),
    values() {
      let vals = {};
      for (let key in this.selects) {
        if (Object.keys(this.selects[key].VALUES).length < 1) {
          continue;
        }
        vals[key] = this.selects[key];
      }
      for (let key in this.checkboxes) {
        if (Object.keys(this.checkboxes[key].VALUES).length < 1) {
          continue;
        }
        vals[key] = this.checkboxes[key];
      }
      return vals;
    },
    classFilterApply: function () {
      return {
        'filter__btn-apply': Object.keys(this.selected).length === 0
      }
    },
    cntFilters() {
      console.log(this.selTags)
      return this.selTags.length
    }
  },
  created() {
    this.setSelected(this.selects);
    this.setSelected(this.checkboxes);
    for (let key in this.selected_items)
      this.selTags[key] = this.selected_items[key];

    console.log(this.selTags)
  }
}
</script>

<style scoped>

</style>